module.exports = __webpack_public_path__ + "static/img/icon6.d6f7c0bb.png";